import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { IFile, IOtherManagementState, ISaveBannerArgs } from '../types';
import otherManagementServices from '../otherManagementServices';
import { batch } from 'react-redux';
import { toastActions } from 'pages/_commons/Toast/_redux';
import { otherManagementActions } from '.';
import { updateFiles } from '../helpers';
import { isArray } from 'lodash';

export const saveBanner = createAsyncThunk<
  unknown,
  ISaveBannerArgs,
  ThunkAPIConfig
>('saveBanner', async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const { selectedBanner } = getState().other.banner;
    dispatch(
      toastActions.addToast({
        show: true,
        message: '파일 업로드 중...',
        type: 'warning'
      })
    );
    const files = await updateFiles(
      selectedBanner?.files || [],
      args.data.files
    );
    if (!isArray(files)) throw new Error();
    const params: ISaveBannerArgs = {
      data: {
        ...args.data,
        files
      }
    };
    await (args.data.id
      ? otherManagementServices.updateBanner(params)
      : otherManagementServices.addBanner(params));

    return batch(() => {
      dispatch(
        toastActions.addToast({
          show: true,
          message: '성공',
          type: 'success'
        })
      );
      dispatch(
        otherManagementActions.getBanners({
          limit: 5
        })
      );
      dispatch(otherManagementActions.setBannerAction('list'));
      dispatch(otherManagementActions.setSelectedBanner());
    });
  } catch (error) {
    dispatch(
      toastActions.addToast({
        show: true,
        message: '오류',
        type: 'error'
      })
    );
    return rejectWithValue(error);
  }
});

export const saveBannerBuilder = (
  builder: ActionReducerMapBuilder<IOtherManagementState>
) => {
  const { pending, fulfilled, rejected } = saveBanner;
  builder
    .addCase(pending, draftState => {
      draftState.banner.loading = true;
    })
    .addCase(fulfilled, draftState => {
      draftState.banner.loading = false;
    })
    .addCase(rejected, draftState => {
      draftState.banner.loading = false;
    });
};
